import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

const translations = {
  en: {
    // Topbar
    "topbar.indep": "Independent Administrative Support",
    "topbar.uk": "Supporting you in the UK",
    // Nav
    "nav.services": "Services",
    "nav.showcase": "Showcase",
    "nav.payments": "Payments",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.whatsapp": "WhatsApp",
    // Welcome
    "welcome.eyebrow": "About Marioway",
    "welcome.headline": "A trusted UK consultancy",
    "welcome.headline.accent": "built for real people.",
    "welcome.p1_before": "Marioway Benefits Consultancy LTD",
    "welcome.p1_mid": "is an independent UK consultancy registered in",
    "welcome.p1_leeds": "Leeds",
    "welcome.p1_after": "We provide independent administrative, welfare support, accounting administration, education support and business support services to individuals, families and small businesses across the UK.",
    "welcome.p2": "From Universal Credit and EU Settlement to Self-Employed Tax, Student Finance and Council Tax Support — we cover every step of your administrative journey under one roof.",
    "welcome.p3": "Our team speaks English, Romanian and Spanish — making sure no one is left behind because of language. Clear, professional support. Long-term assistance.",
    "welcome.stat1.title": "Independent",
    "welcome.stat1.sub": "Administrative Support",
    "welcome.stat2.title": "Trusted",
    "welcome.stat2.sub": "Companies House Registered",
    "welcome.stat3.title": "EN · RO · ES",
    "welcome.stat3.sub": "Multilingual Service",
    "welcome.cta.call": "Call 07383513170",
    "welcome.cta.whatsapp": "WhatsApp",
    "welcome.cta.services": "See 10 core services",
    "welcome.pillar1": "CONSULTANCY",
    "welcome.pillar1.desc": "Professional guidance you can trust.",
    "welcome.pillar2": "ADMINISTRATIVE SUPPORT",
    "welcome.pillar2.desc": "Practical solutions for your everyday needs.",
    "welcome.pillar3": "SOLUTIONS FOR YOU",
    "welcome.pillar3.desc": "Helping you achieve clarity and peace of mind.",
    // Hero
    "hero.eyebrow": "Trusted UK Consultancy",
    "hero.headline1": "Your support.",
    "hero.headline2": "Our priority.",
    "hero.subtext": "Marioway Benefits Consultancy Ltd provides independent administrative, welfare support, accounting administration, education support and business support services to individuals, families and small businesses across the UK. Multilingual support in English, Romanian and Spanish — clear, calm, professional.",
    "hero.qual": "Florin-Marius Bran · BSc Accounting and Financial Management · Canterbury Christ Church University · 2026 · Founder & Director",
    "hero.cta.call": "Call 07383513170",
    "hero.cta.free": "Free initial consultation",
    "hero.card.title": "Free initial 15-minute consultation",
    "hero.card.sub": "No obligation. Confidential.",
    "hero.card.link": "See all 10 core services",
    // Trust bar
    "trust.confidential": "Confidential Service",
    "trust.expert": "Clear Guidance",
    "trust.trusted": "Professional Support",
    "trust.fast": "Practical Solutions",
    // Services Categories
    "cat.eyebrow": "10 Core Services",
    "cat.headline1": "Complete support",
    "cat.headline2": "under one roof.",
    "cat.subtext": "From welfare benefits to immigration documentation, education to accounting administration, paperwork to administrative disputes — practical support under one roof. Personalised, multilingual support delivered with care.",
    "cat.cta": "Get personalised support",
    // Simple Words
    "simple.eyebrow": "In Simple Words",
    "simple.headline1": "What we do —",
    "simple.headline2": "explained simply.",
    "simple.subtext": "No complicated words. Just the 6 things we help you with every single day.",
    "simple.1.title": "We help you with your benefits paperwork",
    "simple.1.desc": "Universal Credit, Child Benefit, PIP, Council Tax — we help you complete the forms, organise your evidence and understand the process. The decision is always made by the relevant authority.",
    "simple.2.title": "We help you organise your UK documents",
    "simple.2.desc": "EU Settlement documents, ETA, Share Code, residency papers — we help you organise documents and use GOV.UK digital services. This is administrative support, not immigration advice.",
    "simple.3.title": "We help with your tax paperwork",
    "simple.3.desc": "Self Assessment documentation, bookkeeping, payroll administration, HMRC letters — we keep your records organised so you can focus on your work and family.",
    "simple.4.title": "We support you with school and university",
    "simple.4.desc": "Student Finance, university applications, enrolment paperwork — we guide you or your children through the education paperwork.",
    "simple.5.title": "We help you when something goes wrong",
    "simple.5.desc": "Benefit refused? Overpayment letter? Mandatory Reconsideration? We help you prepare the letters and organise the evidence — calm, professional, on your side. We are not a law firm.",
    "simple.6.title": "We do the paperwork you hate",
    "simple.6.desc": "Applications, letters, official documents, DBS, driving licence, birth certificates — anything with a form, we handle it for you.",
    "simple.cta": "Talk to us about your situation",
    "simple.cta.sub": "Free initial 15-minute chat. No obligation. Confidential.",
    // Contact
    "contact.eyebrow": "Get in touch",
    "contact.headline1": "Call or WhatsApp for a",
    "contact.headline2": "free initial 15-minute consultation.",
    "contact.subtext": "Prefer to speak directly? Reach us on the number below — or drop a message and we'll come back to you the same working day.",
    "contact.form.name": "Full name *",
    "contact.form.name.ph": "Your name",
    "contact.form.email": "Email *",
    "contact.form.phone": "Phone",
    "contact.form.phone.ph": "UK mobile (optional)",
    "contact.form.service": "Service",
    "contact.form.service.ph": "Select a service",
    "contact.form.message": "Your message *",
    "contact.form.message.ph": "Tell us briefly how we can help…",
    "contact.form.secure": "Secure & confidential",
    "contact.form.submit": "Send message",
    "contact.form.sending": "Sending…",
    "contact.form.success": "Thanks — your enquiry has been received.",
    "contact.confidential": "Your details are kept strictly confidential.",
    // Footer
    "footer.qual.title": "Founder & Director",
    "footer.qual.body1": "Florin-Marius Bran — BSc Accounting and Financial Management",
    "footer.qual.body2": "Canterbury Christ Church University · 2026",
    "footer.qual.body3": "Founder & Director, Marioway Benefits Consultancy Ltd.",
    "footer.qual.disclaimer": "Academic qualifications are stated for transparency. Professional or regulated services are provided only where Marioway holds the appropriate authorisation or where the activity does not require regulatory authorisation.",
    "footer.rights": "Independent administrative and consultancy services. Not affiliated with or endorsed by any UK government department or public authority.",
  },
  ro: {
    // Topbar
    "topbar.indep": "Suport Administrativ Independent",
    "topbar.uk": "Vă sprijinim în Marea Britanie",
    // Nav
    "nav.services": "Servicii",
    "nav.showcase": "Galerie",
    "nav.payments": "Plăți",
    "nav.about": "Despre noi",
    "nav.contact": "Contact",
    "nav.whatsapp": "WhatsApp",
    // Welcome
    "welcome.eyebrow": "Despre Marioway",
    "welcome.headline": "Consultanță UK de încredere,",
    "welcome.headline.accent": "construită pentru oameni reali.",
    "welcome.p1_before": "Marioway Benefits Consultancy LTD",
    "welcome.p1_mid": "este o consultanță UK independentă, înregistrată în",
    "welcome.p1_leeds": "Leeds",
    "welcome.p1_after": "Oferim servicii independente de suport administrativ, sprijin pentru beneficii sociale, administrare contabilă, sprijin educațional și suport pentru afaceri, persoanelor fizice, familiilor și afacerilor mici din întreg UK.",
    "welcome.p2": "De la Universal Credit și EU Settlement până la taxe pentru PFA, Student Finance și Council Tax — acoperim fiecare pas al drumului tău administrativ sub un singur acoperiș.",
    "welcome.p3": "Echipa noastră vorbește română, engleză și spaniolă — ne asigurăm că nimeni nu rămâne în urmă din cauza limbii. Sprijin clar și profesional. Asistență pe termen lung.",
    "welcome.stat1.title": "Independent",
    "welcome.stat1.sub": "Suport Administrativ",
    "welcome.stat2.title": "De încredere",
    "welcome.stat2.sub": "Înregistrat la Companies House",
    "welcome.stat3.title": "EN · RO · ES",
    "welcome.stat3.sub": "Serviciu Multilingv",
    "welcome.cta.call": "Sună 07383513170",
    "welcome.cta.whatsapp": "WhatsApp",
    "welcome.cta.services": "Vezi cele 10 servicii",
    "welcome.pillar1": "CONSULTANȚĂ",
    "welcome.pillar1.desc": "Îndrumare profesională în care poți avea încredere.",
    "welcome.pillar2": "SUPORT ADMINISTRATIV",
    "welcome.pillar2.desc": "Soluții practice pentru nevoile tale zilnice.",
    "welcome.pillar3": "SOLUȚII PENTRU TINE",
    "welcome.pillar3.desc": "Te ajutăm să ai claritate și liniște sufletească.",
    // Hero
    "hero.eyebrow": "Consultanță UK de Încredere",
    "hero.headline1": "Sprijinul tău.",
    "hero.headline2": "Prioritatea noastră.",
    "hero.subtext": "Marioway Benefits Consultancy Ltd oferă servicii independente de suport administrativ, sprijin pentru beneficii sociale, administrare contabilă, sprijin educațional și suport pentru afaceri, persoanelor fizice, familiilor și afacerilor mici din întreg UK. Ajutor multilingv în engleză, română și spaniolă — clar, calm, profesional.",
    "hero.qual": "Florin-Marius Bran · BSc Accounting and Financial Management · Canterbury Christ Church University · 2026 · Fondator & Director",
    "hero.cta.call": "Sună 07383513170",
    "hero.cta.free": "Consultație inițială gratuită",
    "hero.card.title": "Consultație inițială gratuită de 15 minute",
    "hero.card.sub": "Fără obligații. Confidențial.",
    "hero.card.link": "Vezi toate cele 10 servicii",
    // Trust bar
    "trust.confidential": "Serviciu Confidențial",
    "trust.expert": "Îndrumare Clară",
    "trust.trusted": "Sprijin Profesional",
    "trust.fast": "Soluții Practice",
    // Services Categories
    "cat.eyebrow": "10 Servicii Principale",
    "cat.headline1": "Sprijin complet",
    "cat.headline2": "sub un singur acoperiș.",
    "cat.subtext": "De la beneficii sociale la documente de imigrație, de la educație la administrare contabilă, de la acte la dispute administrative — sprijin practic sub un singur acoperiș. Suport personalizat, multilingv, cu grijă.",
    "cat.cta": "Primește suport personalizat",
    // Simple Words
    "simple.eyebrow": "Pe înțelesul tuturor",
    "simple.headline1": "Ce facem —",
    "simple.headline2": "explicat simplu.",
    "simple.subtext": "Fără cuvinte complicate. Doar cele 6 lucruri cu care te ajutăm în fiecare zi.",
    "simple.1.title": "Te ajutăm cu actele pentru beneficii",
    "simple.1.desc": "Universal Credit, Child Benefit, PIP, Council Tax — te ajutăm să completezi formularele, să organizezi dovezile și să înțelegi procesul. Decizia o ia întotdeauna autoritatea competentă.",
    "simple.2.title": "Te ajutăm să-ți organizezi actele UK",
    "simple.2.desc": "Documente EU Settlement, ETA, Share Code, acte de rezidență — te ajutăm să organizezi documentele și să folosești serviciile digitale GOV.UK. Este suport administrativ, nu consultanță de imigrație.",
    "simple.3.title": "Te ajutăm cu actele pentru taxe",
    "simple.3.desc": "Documente Self Assessment, contabilitate, administrare salarii, scrisori HMRC — îți ținem evidențele în ordine, tu te concentrezi pe muncă și familie.",
    "simple.4.title": "Te ajutăm cu școala și universitatea",
    "simple.4.desc": "Student Finance, aplicații la universități, acte de înscriere — te ghidăm pe tine sau copilul tău prin actele sistemului educațional britanic.",
    "simple.5.title": "Te ajutăm când apare o problemă",
    "simple.5.desc": "Beneficiu refuzat? Scrisoare de plată în plus? Mandatory Reconsideration? Te ajutăm să pregătești scrisorile și să organizezi dovezile — calm, profesional, de partea ta. Nu suntem o firmă de avocatură.",
    "simple.6.title": "Facem actele pe care le urăști",
    "simple.6.desc": "Aplicații, scrisori, documente oficiale, DBS, permis auto, certificate naștere — orice are formular, noi îl completăm pentru tine.",
    "simple.cta": "Spune-ne situația ta",
    "simple.cta.sub": "Discuție inițială gratuită de 15 minute. Fără obligații. Confidențial.",
    // Contact
    "contact.eyebrow": "Ia legătura",
    "contact.headline1": "Sună sau WhatsApp pentru o",
    "contact.headline2": "consultație inițială gratuită de 15 minute.",
    "contact.subtext": "Preferi să vorbești direct? Ne găsești la numărul de mai jos — sau lasă-ne un mesaj și îți răspundem în aceeași zi lucrătoare.",
    "contact.form.name": "Nume complet *",
    "contact.form.name.ph": "Numele tău",
    "contact.form.email": "Email *",
    "contact.form.phone": "Telefon",
    "contact.form.phone.ph": "Număr UK (opțional)",
    "contact.form.service": "Serviciu",
    "contact.form.service.ph": "Alege un serviciu",
    "contact.form.message": "Mesajul tău *",
    "contact.form.message.ph": "Spune-ne pe scurt cum te putem ajuta…",
    "contact.form.secure": "Sigur & confidențial",
    "contact.form.submit": "Trimite mesajul",
    "contact.form.sending": "Se trimite…",
    "contact.form.success": "Mulțumim — mesajul tău a fost primit.",
    "contact.confidential": "Datele tale rămân strict confidențiale.",
    // Footer
    "footer.qual.title": "Fondator & Director",
    "footer.qual.body1": "Florin-Marius Bran — BSc Accounting and Financial Management",
    "footer.qual.body2": "Canterbury Christ Church University · 2026",
    "footer.qual.body3": "Fondator & Director, Marioway Benefits Consultancy Ltd.",
    "footer.qual.disclaimer": "Calificările academice sunt menționate pentru transparență. Serviciile profesionale sau reglementate sunt oferite doar acolo unde Marioway deține autorizarea corespunzătoare sau unde activitatea nu necesită autorizare.",
    "footer.rights": "Servicii independente de suport administrativ și consultanță. Neafiliat și neaprobat de niciun departament guvernamental sau autoritate publică din UK.",
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "ro";
    return localStorage.getItem("mw_lang") || "ro";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("mw_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
